import React from "react";
import OffLineDashboardLeft from "../../OffLineSupport-Panel/dashboard-left/index";
import OffLineDashboardRight from "../../OffLineSupport-Panel/dashboard-right/index";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles({
    container: {
        display: 'flex',
        padding: "20px"
    }
});

interface Props {
    children: any;
}

const OffLineAgentDash: React.FC<Props> = ({ children }) => {
    const classes = useStyles();
    return (
        <div className={classes.container}>
            <OffLineDashboardLeft />
            <OffLineDashboardRight>{children && children}</OffLineDashboardRight>
        </div>
    );
};

export default OffLineAgentDash;

